import { useMemo, useRef } from "react";
import _isEqual from "./auth-service-tools156.js";

function useDeepCompareMemoize(value) {
  const ref = useRef();
  if (!value) return void 0;

  if (!_isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}

const useDeepMemo = (factory, deps) => // @ts-ignore-next-line
// eslint-disable-next-line react-hooks/exhaustive-deps
useMemo(factory, useDeepCompareMemoize(deps));

export { useDeepMemo };